export default "/shETH.210ce6e166f330ffdd6ff9366d3f6655.svg";